import React, { useContext } from 'react';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { GridContext } from '@bingads-webui-grid/grid-context';
import { getSearchRangeString } from './get-search-range';

export const onRenderHeader = (title, topicId, i18n) => (
  <div>
    <span className="grid-header-text">
      {title}
    </span>
    {
      topicId && (
        <span className="grid-header-helpId">
          <HelpPopup topic={topicId} aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: title })} />
        </span>
      )
    }
  </div >
);

export const columnOrder = i18n => ({
  key: 'ColumnOrder',
  name: i18n.getString(_TL_('#')),
  fieldName: 'Order',
  minWidth: 30,
  maxWidth: 60,
  // isResizable: true,
  sortable: false,
  onRender: (_item, index) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { state } = useContext(GridContext);
    const { pagination } = state;
    const { pageNumber, pageSize } = pagination;
    return `#${i18n.formatDecimal(((pageNumber - 1) * pageSize) + index + 1, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  },
});

export const columnKeyword = i18n => ({
  key: 'Keyword',
  name: i18n.getString(_TL_('Keyword')),
  fieldName: 'Keyword',
  minWidth: 100,
  maxWidth: 200,
  isResizable: true,
  sortable: false,
});

export const columnSearches = i18n => ({
  key: 'ColumnSearches',
  name: 'ColumnSearches',
  fieldName: 'AggregateMetric/AverageSearchVolume',
  minWidth: 100,
  maxWidth: 120,
  isResizable: true,
  sortable: true,
  onRender: item => getSearchRangeString(item.AggregateMetric.AverageSearchVolume, i18n),
  onRenderHeader: () => onRenderHeader(i18n.getString(_TL_('Searches')), 'pop_BA_CampaignCreate_Keywords_MonthlySearches', i18n),
});

export const columns = i18n => [
  columnOrder(i18n),
  columnKeyword(i18n),
  columnSearches(i18n),
];
